export const EVENT_ADD_TO_CART = "ww:add-to-cart";
export const EVENT_NAVIGATE_CHAT = "ww:navigate:chat";
export const EVENT_NAVIGATE_PRODUCT = "ww:navigate:product";
export const EVENT_ADD_TO_CART_SUCCESS = "ww:add-to-cart:success";
export const EVENT_ADD_TO_CART_ERROR = "ww:add-to-cart:error";
export const EVENT_NAVIGATE_PRODUCT_SUCCESS = "ww:navigate:product:success";
export const EVENT_NAVIGATE_PRODUCT_ERROR = "ww:navigate:product:error";
export const EVENT_STATUS = "ww:status";
export const EVENT_DELTA = "ww:delta";
export const EVENT_CANDIDATES = "ww:candidates";
export const EVENT_QA_USED = "ww:qa:used";

export interface CandidatesEventDetail {
  storeId?: string;
  sessionId?: string;
  search_id?: string;
  candidates?: Array<Record<string, unknown>>;
  query_title?: string | null;
  results_count?: number | null;
  phase?: "recommendation" | "question";
  [key: string]: unknown;
}

export interface AddToCartEventDetail {
  storeId?: string;
  sessionId?: string;
  searchId?: string;
  fromInstanceId?: string;
  product?: {
    id?: string | number;
    title?: string;
    images?: string[];
    rawImageObjects?: Array<Record<string, unknown>>;
    price?: string;
    productHandle?: string;
    productUrl?: string;
    description?: string;
  };
  selectedVariant?: Record<string, string>;
  quantity?: number;
  variantId?: string | number;
  variant_names?: string[] | null;
  picked_variant_values?: string[] | null;
}

export interface NavigateProductEventDetail {
  storeId?: string;
  sessionId?: string;
  searchId?: string;
  fromInstanceId?: string;
  product?: {
    id?: string | number;
    title?: string;
    images?: string[];
    rawImageObjects?: Array<Record<string, unknown>>;
    price?: string;
    productHandle?: string;
    productUrl?: string;
    description?: string;
  };
  selectedVariant?: Record<string, string>;
  quantity?: number;
  variantId?: string | number;
  variant_names?: string[] | null;
  picked_variant_values?: string[] | null;
  target?: string;
}
export const EVENT_ERROR = "ww:error";

export function emitGlobalEvent(eventName: string, detail?: unknown) {
  try {
    (window as any).Wandway?.emit?.(eventName, detail);
  } catch {}
  try {
    const ev = new CustomEvent(eventName, { detail, bubbles: true, composed: true, cancelable: true });
    document.dispatchEvent(ev);
  } catch {}
}


